export const GET_SITE_SETTING_DETAILS = "GET_SITE_SETTING_DETAILS";
export const GET_SITE_SETTING_DETAILS_SUCCESSFUL = "GET_SITE_SETTING_DETAILS_SUCCESSFUL";
export const GET_SITE_SETTING_DETAILS_FAILED = "GET_SITE_SETTING_DETAILS_FAILED";